<template>
  <div>
    <!-- 筛选 -->
    <el-form ref="Form" :inline="true" class="searchBoxLine my-search-line" :model="searchForm">
      <el-form-item label="申请单号：" prop="approvalNumber">
        <el-input v-model="searchForm.approvalNumber" placeholder="申请单号" />
      </el-form-item>
      <el-form-item label="项目名称：" prop="projectName">
        <el-input v-model="searchForm.projectName" placeholder="项目名称" />
      </el-form-item>
      <el-form-item label="合同编号：" prop="contractNum">
        <el-input v-model="searchForm.contractNum" placeholder="合同编号" @blur="searchForm.contractNum = (searchForm.contractNum || '').trim()" />
      </el-form-item>
      <el-form-item label="代理商名称：" prop="orderUnit">
        <el-input v-model="searchForm.orderUnit" placeholder="代理商名称" />
      </el-form-item>
      <el-form-item label="申请时间：" prop="createBeginTime">
        <div class="rj-flex">
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createBeginTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
          <div style="display: inline-block;width: 10px;text-align: center">
            -
          </div>
          <div class="rj-flex__item">
            <el-date-picker
              v-model="searchForm.createEndTime"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            />
          </div>
        </div>
      </el-form-item>
      <el-form-item>
        <el-button ref="searchBtn" type="primary" :loading="isLoading" @click="initData('search')">
          查询
        </el-button>
        <el-button type="default" @click="resetForm">
          重置
        </el-button>
        <el-button type="default" @click="exportInfo">
          导出已开票信息
        </el-button>
      </el-form-item>
    </el-form>

    <!-- Table表格 -->
    <div v-loading="isLoading" class="tableBody">
      <el-table :data="tableData" border style="width: 100%" tooltip-effect="light">
        <el-table-column prop="approvalNumber" label="申请单号" align="left" fixed="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handleNum(row)">
              {{ row.approvalNumber }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" align="left" fixed="left" />
        <el-table-column prop="contractNum" label="合同编号" align="left" />
        <el-table-column prop="orderUnit" label="代理商名称" align="left" />
        <el-table-column prop="invoiceAmount" label="开票金额" align="right" header-align="left" />
        <el-table-column prop="revMethod" label="收入确认方式" align="left" />
        <el-table-column prop="revRule" label="收入确认规则" align="left" />
        <el-table-column prop="customerType" label="客户类型" align="left" />
        <el-table-column prop="applicantName" label="申请人" align="left" />
        <el-table-column prop="applicationTime" label="申请时间" align="left" />
        <el-table-column prop="stateStr" label="状态信息" align="left" />
        <el-table-column prop="invoiceCode" label="发票代码" align="left" />
        <el-table-column prop="logisticsNo" label="快递单号" align="left">
          <template v-slot="{row}">
            <el-button type="text" @click="handlelogistics(row)">
              {{ row.logisticsNo }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column prop="erpConfirm" label="是否已核准" align="left" width="180">
          <template v-slot="{row}">
            <span>{{ row.erpConfirm ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="syncState" label="是否到erp" align="left">
          <template v-slot="{row}">
            <span>{{ row.syncState ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="transferFromCode" label="操作" align="left" fixed="right">
          <template v-slot="{row}">
            <el-button v-if="row.operationFlag === 1" type="text" @click="openRecall(row)">
              召回
            </el-button>
            <el-button v-if="row.operationFlag === 2" type="text" @click="handleEdit(row)">
              编辑
            </el-button>
            <el-button v-if="row.operationFlag === 2" type="text" @click="openDiscard(row)">
              废弃
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div style="text-align: right;margin-top: 10px">
        <el-pagination
          :page-sizes="[10]"
          :page-size.sync="page.pageSize"
          :current-page.sync="page.pageIndex"
          :total="page.total"
          layout="total, prev, pager, next, jumper, sizes"
          @size-change="handerSizeChange"
          @current-change="handerCurrentChange"
        />
      </div>
    </div>

    <!-- 申请单号 -->
    <notice-dialog
      ref="noticeRef"
      :is-show="isApplyShow"
      :form-data="detailInfo"
      :is-receipt="true"
      @down-file="downFile"
      @handle-cancel="isApplyShow = false"
    />

    <!-- 快递单号 -->
    <logisticsProcess
      ref="logisticsRef"
      :is-show="islogisticsShow"
      :form-data="rowDetail"
      @handle-cancel="islogisticsShow = false"
    />

    <!-- 编辑 -->
    <base-info
      ref="baseInfoRef"
      :from-info="detailInfo"
      view-type="edit"
      @chang-client="changClient"
      @handle-submit="handleSubmit"
      @handle-remove="handleRemove"
    />
    <a ref="downTag" :href="fileserveDownUrl" target="_blank" />
  </div>
</template>

<script>
// 申请单号
import noticeDialog from '@/components/noticeDialog';
// 编辑
import baseInfo from '@/components/baseInfo';
// 快递单号
import logisticsProcess from '@/components/logisticsProcess';
import {
  pageQueryAppliedInvoice,
  processRecall,
  exportInvoicedInfo,
  editApply,
  deleteApply,
  getProcessinfo,
  attachmentGetToken
} from '@/API';
export default {
  components: {
    noticeDialog,
    baseInfo,
    logisticsProcess
  },

  data () {
    return {
      isLoading: false,
      isApplyShow: false, // 申请单号
      islogisticsShow: false, // 快递单号
      isEditShow: false, // 编辑
      searchForm: {},
      tableData: [],
      detailInfo: {}, // 申请单号信息
      rowDetail: {},
      token: '',
      downloadUrl: '',
      fileserveDownUrl: '',
      page: {
        pageSize: 10,
        pageIndex: 1,
        total: 0
      }
    };
  },

  mounted () {
    this.initData();
    this.initToken();
  },

  methods: {
    initData (type) {
      this.isLoading = true;
      if (type === 'search') {
        this.page.pageIndex = 1;
      }
      const params = {
        ...this.searchForm,
        ...this.page,
        approved: true,
        approvalRole: 1
      };
      pageQueryAppliedInvoice(params).then(res => {
        const { data } = res.data;
        this.page.total = data.total;
        this.tableData = data.list;
        this.isLoading = false;
      }).catch(e => {
        console.log(e);
        this.isLoading = false;
      });
    },

    // 编辑 开票客户名称变动 字段更改
    changClient (val = '', list = []) {
      const item = list.find(i => i.kpOrderUnit === val);
      this.detailInfo = {
        ...this.detailInfo,
        kpOrderUnitTemp: val,
        bankInfo: {
          ...this.detailInfo.bankInfo,
          kpOrderUnitCode: item && item.kpOrderUnitCode,
          kpTaxpayerNum: item && item.kpTaxpayerNum,
          taxRegistrationAddress: item && item.taxRegistrationAddress,
          taxRegistrationTelephone: item && item.taxRegistrationTelephone,
          bankDeposit: item && item.bankDeposit,
          bankAccount: item && item.bankAccount
        }
      };
    },

    // 申请单号
    handleNum (item) {
      this.rowDetail = {};
      this.rowDetail = item;
      this.isApplyShow = true;
      // 申请单号和编辑都需要回显
      getProcessinfo({
        approvalNumber: item.approvalNumber,
        approval: false
      }).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.detailInfo = data.data || {};
        }
      });
    },

    // 快递单号
    handlelogistics (row) {
      this.islogisticsShow = true;
      this.$refs.logisticsRef.initData(row.logisticsNo);
    },

    // 打开编辑窗口
    handleEdit (row) {
      this.rowDetail = {};
      this.rowDetail = row;
      this.$refs.baseInfoRef.openDialog();
      getProcessinfo({
        approvalNumber: row.approvalNumber,
        approval: true
      }).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.detailInfo = data.data || {};
          this.detailInfo.kpOrderUnitTemp = this.detailInfo.bankInfo.kpOrderUnit;
          if (this.detailInfo.fileName && (Number(this.detailInfo.fileName) !== 0)) {
            this.detailInfo.fileListTemp = [{
              name: this.detailInfo.fileName,
              fileToken: this.detailInfo.fileToken
            }];
          }
        }
      });
    },

    // 删除文件
    handleRemove () {
      this.detailInfo.fileListTemp.splice(0);
    },

    // 编辑提交
    handleSubmit () {
      const { fileListTemp, invoiceMark, invoiceType, invoiceEmail } = this.detailInfo;
      if (!invoiceType) {
        this.$message.error('金税发票类型必填');
        return;
      }
      if (!invoiceMark) {
        this.$message.error('发票标记必填');
        return;
      }
      if (invoiceType === 2 && !(invoiceEmail && invoiceEmail.length)) {
        this.$message.error('金税发票类型选择的是“增值税电子普通发票”时，发票接收邮箱必填');
        return;
      }
      const temp = this.detailInfo.productList.map(item => {
        return {
          ...item,
          id: null
        };
      });
      this.detailInfo.productList = temp;
      const params = {
        ...this.detailInfo,
        fileToken: fileListTemp && fileListTemp.length && fileListTemp[0].fileToken,
        fileName: fileListTemp && fileListTemp.length && fileListTemp[0].name,
        bankInfo: {
          ...this.detailInfo.bankInfo,
          kpOrderUnit: this.detailInfo.kpOrderUnitTemp
        }
      };
      delete params.kpOrderUnitTemp;
      delete params.fileListTemp;
      editApply(params).then(res => {
        const { data } = res;
        if (data.status === '200') {
          this.$refs.baseInfoRef.handleCancel();
          this.initData();
          this.$message.success('提交成功');
          this.detailInfo = {};
        }
      });
    },

    // 召回
    openRecall (row) {
      this.$confirm('注：召回后可以重新编辑后再提交，也可以废弃。', '您确定要召回此开票申请吗？', {
        confirmButtonText: '召回',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        processRecall({
          approvalNumber: row.approvalNumber
        }).then(res => {
          const { data } = res;
          if (data.status === '200') {
            this.$message({
              type: 'success',
              message: '召回成功'
            });
            this.initData();
          }
        });
      }).catch((e) => {
        console.log(e);
      });
    },

    // 废弃
    openDiscard (row) {
      this.$confirm('您确定要废弃此开票申请吗？', '', {
        confirmButtonText: '废弃',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteApply({
          approvalNumber: row.approvalNumber
        }).then(res => {
          const { data } = res;
          if (data.status === '200') {
            this.$message({
              type: 'success',
              message: '废弃成功'
            });
            this.initData();
          }
        });
      }).catch((e) => {
        console.log(e);
      });
    },

    // 导出
    exportInfo () {
      exportInvoicedInfo({
        // 6 = 流程结束
        state: 6,
        ...this.searchForm
      }).then((res) => {
        const content = res.data;
        const blob = new Blob([content]);
        const fileName = '开票信息' + new Date().toLocaleString() + '.xlsx';
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          const link = document.createElement('a');
          link.download = fileName;
          link.style.display = 'none';
          link.href = URL.createObjectURL(blob);
          document.body.appendChild(link);
          link.click();
          URL.revokeObjectURL(link.href);
          document.body.removeChild(link);
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    initToken () {
      attachmentGetToken().then((res) => {
        let json = res.data;
        console.log(res, 'res');
        if (json.status === '200') {
          this.token = json.data.token;
          this.downFileUrl = json.data.downloadUrl;
        }
      }).catch((err) => {
        console.log(err);
      });
    },

    downFile (row) {
      this.fileserveDownUrl = this.downFileUrl + `/${row.fileToken}?Token=${this.token}`;
      this.$nextTick(() => {
        this.$refs.downTag.click();
      });
    },

    handerSizeChange () {
      this.page.pageIndex = 1;
      this.initData();
    },

    handerCurrentChange () {
      this.initData();
    },

    resetForm () {
      this.searchForm = {};
      this.page.pageIndex = 1;
      this.page.pageSize = 10;
      this.initData();
    }
  }
};
</script>

<style lang="scss" scoped>
.my-search-line {
  margin-bottom: 12px;
}
</style>
